<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
      </app-form-save-button>
    </app-pageheader>
    <div class="columns is-centered">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            Customer Group Details
          </p>
          <div class="panel-block">
            <div style="width: 100%;">
              <app-field Label="Name" [Required]="true">
                <div class="control">
                  <input formControlName="Name" class="input" type="text" placeholder="Enter customer group name">
                  <app-validator [For]="Form.get('Name')"></app-validator>
                </div>
              </app-field>
              <app-field Label="Description">
                <div class="control">
                  <textarea formControlName="Description" class="textarea" rows="3" placeholder="Enter description (optional)"></textarea>
                  <app-validator [For]="Form.get('Description')"></app-validator>
                </div>
              </app-field>
              <app-field Label="External Id">
                <div class="control">
                  <input formControlName="ExternalId" class="input" type="text" placeholder="Enter customer group External Id">
                  <app-validator [For]="Form.get('ExternalId')"></app-validator>
                </div>
              </app-field>
            </div>
          </div>
        </article>
        <article class="panel">
          <p class="panel-heading">
            Capacity Settings
          </p>
          <div class="panel-block">
            <div style="width: 100%;">
              <app-field Label="Total Spaces" [Required]="true" HelpText="Maximum number of concurrent parking sessions allowed for this customer group">
                <div class="control">
                  <input formControlName="TotalSpaces" class="input" type="number" min="0" placeholder="Maximum concurrent sessions allowed">
                  <app-validator [For]="Form.get('TotalSpaces')"></app-validator>
                </div>
              </app-field>
              <app-field Label="Reserved Spaces" HelpText="Number of spaces reserved and not available for general use">
                <div class="control">
                  <input formControlName="ReservedSpaces" class="input" type="number" min="0" placeholder="Number of reserved spaces">
                  <app-validator [For]="Form.get('ReservedSpaces')"></app-validator>
                </div>
              </app-field>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}